import { call, put, takeEvery } from "redux-saga/effects";
import { GET_MATCHING_DATA } from "./actionTypes";
import { getMatchingDataSuccess, getMatchingDataFail } from "./actions";
import { getMatchingCandidates } from "../../../helpers/fakebackend_helper";
import * as url from "../../../helpers/url_helper";

function* getMatchingData({ payload }) {
  try {
    const jobId = payload;

    const response = yield call(
      getMatchingCandidates,
      `${url.GET_MATCHING_CANDIDATES}?jobId=${jobId}&pageNo=0&pageSize=10`,
    );

    yield put(getMatchingDataSuccess(response));
  } catch (error) {
    yield put(getMatchingDataFail(error));
  }
}

function* matchingSaga() {
  yield takeEvery(GET_MATCHING_DATA, getMatchingData);
}

export default matchingSaga;
